import { type CategoryTypes } from "~/models/category"
import type { PayrollType } from "~/models/payroll"
import type { PerformanceReviewType } from "~/models/performance-review"

export default {
	HomeUrl: () => "/",
	LoginUrl: () => "/auth",
	ContactUsUrl: () => "/contact-us",
	AboutUsUrl: () => "/about-us",
	RulesUrl: () => "/rules",
	SurveyUrl: (companyId: number, surveyId: number, secretCode: string) =>
		`/survey-${companyId}-${surveyId}-${secretCode}`,
	// blog
	BlogUrl: () => `/blog`,
	BlogPageUrl: (page: number) => `/blog/page/${page}`,
	BlogCategoryUrl: (categoryId: number) => `/blog/category/${categoryId}`,
	BlogCategoryPageUrl: (categoryId: number, page: number) => `/blog/category/${categoryId}/page/${page}`,
	BlogKeywordUrl: (keywordSlug: string) => `/blog/keyword-${keywordSlug}`,
	BlogKeywordPageUrl: (keywordSlug: string, page: number) => `/blog/keyword-${keywordSlug}/page/${page}`,
	BlogArticleUrl: (articleId: number) => `/blog/single/${articleId}`,
	// help
	HelpUrl: () => `/help`,
	HelpPageUrl: (page: number) => `/help/page/${page}`,
	HelpCategoryUrl: (categoryId: number) => `/help/category/${categoryId}`,
	HelpCategoryPageUrl: (categoryId: number, page: number) => `/help/category/${categoryId}/page/${page}`,
	HelpKeywordUrl: (keywordSlug: string) => `/help/keyword-${keywordSlug}`,
	HelpKeywordPageUrl: (keywordSlug: string, page: number) => `/help/keyword-${keywordSlug}/page/${page}`,
	HelpPostUrl: (helpId: number) => `/help/single/${helpId}`,
	// company
	CompanyLoginUrl: (companyId: number) => `/company/${companyId}/auth`,
	CompanyDashboardUrl: () => `/company`,
	CompanyTimeAttendanceDashboardUrl: () => "/company/time-attendance/dashboard",
	CompanyPayrollDashboardUrl: () => "/company/payrolls/dashboard",
	CompanyPerformanceDashboardUrl: () => "/company/performance-reviews/dashboard",
	CompanyCommunicationDashboardUrl: () => "/company/communication/dashboard",
	CompanyWorkspaceDashboardUrl: () => "/company/workspace/dashboard",
	CompanyWorkspaceOverviewUrl: () => "/company/workspace/overview",
	CompanyAdministrationDashboardUrl: () => "/company/administration/dashboard",
	CompanyPayrollsUrl: (type: string) => `/company/payrolls/${type}`,
	CompanyPayrollsPageUrl: (type: string, page: number) => `/company/payrolls/${type}/page/${page}`,
	CompanyPerformanceReviewsUrl: (type: string) => `/company/performance-reviews/${type}`,
	CompanyPerformanceReviewsPageUrl: (type: string, page: number) =>
		`/company/performance-reviews/${type}/page/${page}`,
	CompanyCustomPageUrl: (customPageId: number) => `/company/custom-pages/${customPageId}`,
	CompanyCareersUrl: (companyId: number) => `/company/${companyId}/careers`,
	CompanyCareerUrl: (companyId: number, careerId: number) => `/company/${companyId}/careers/${careerId}`,
	// panel chat
	CompanyChatUrl: () => `/company/chat`,
	// company projects
	CompanyProjectsUrl: () => `/company/projects`,
	CompanyProjectsPageUrl: (page: number) => `/company/projects/page/${page}`,
	CompanyProjectTasksUrl: (projectId: number) => `/company/projects/${projectId}/tasks`,
	CompanyProjectInvitationsUrl: () => `/company/projects/invitations`,
	CompanyProjectInvitationsPageUrl: (page: number) => `/company/projects/invitations/page/${page}`,
	// company tasks
	CompanyTasksUrl: () => `/company/tasks`,
	CompanyTasksPageUrl: (page: number) => `/company/tasks/page/${page}`,
	// company inbox
	CompanyInboxUrl: () => `/company/inbox`,
	// company disciplinary notes
	CompanyDisciplinaryNotesUrl: () => `/company/disciplinary-notes`,
	// company announcements
	CompanyAnnouncementsUrl: () => `/company/announcements`,
	// company surveys
	CompanySurveysUrl: () => `/company/surveys`,
	// company reserve food
	CompanyReserveFoodUrl: () => `/company/reserve-food`,
	// company settings
	CompanySettingsUrl: () => `/company/settings`,
	// company mails
	CompanyMailsUrl: () => `/company/mails`,
	CompanyMailsPageUrl: (page: number) => `/company/mails/page/${page}`,
	CompanyMailUrl: (noteId: number) => `/company/mails/${noteId}`,
	// company benefit funds
	CompanyBenefitFundsUrl: () => `/company/benefit-funds`,
	CompanyBenefitFundsLoansUrl: () => `/company/benefit-funds/loans`,
	CompanyBenefitFundsLotteriesUrl: () => `/company/benefit-funds/lotteries`,
	// panel attendances
	CompanyAttendancesUrl: () => `/company/attendances`,
	// panel
	PanelDashboardUrl: () => "/panel/dashboard",
	PanelPeopleDashboardUrl: () => "/panel/people/dashboard",
	PanelRecruitmentDashboardUrl: () => "/panel/recruitment/dashboard",
	PanelTimeAttendanceDashboardUrl: () => "/panel/time-attendance/dashboard",
	PanelPayrollDashboardUrl: () => "/panel/payrolls/dashboard",
	PanelPerformanceDashboardUrl: () => "/panel/performance-reviews/dashboard",
	PanelCommunicationDashboardUrl: () => "/panel/communication/dashboard",
	PanelWorkspaceDashboardUrl: () => "/panel/workspace/dashboard",
	PanelAdministrationDashboardUrl: () => "/panel/administration/dashboard",
	PanelCmsDashboardUrl: () => "/panel/cms/dashboard",
	// panel payrolls
	PanelPayrollsUrl: (type: PayrollType) => `/panel/payrolls/${type}`,
	PanelPayrollsPageUrl: (type: string, page: any) => `/panel/payrolls/${type}/page/${page}`,
	PanelEditPayrollColumnsUrl: (type: string) => `/panel/payrolls/${type}/groups/columns`,
	PanelPayrollGroupsUrl: (type: string) => `/panel/payrolls/${type}/groups`,
	PanelPayrollGroupsPageUrl: (type: string, page: any) => `/panel/payrolls/${type}/groups/page/${page}`,
	// panel performance reviews
	PanelPerformanceReviewsUrl: (type: PerformanceReviewType) => `/panel/performance-reviews/${type}`,
	PanelPerformanceReviewsPageUrl: (type: string, page: any) => `/panel/performance-reviews/${type}/page/${page}`,
	PanelEditPerformanceReviewColumnsUrl: (type: string) => `/panel/performance-reviews/${type}/groups/columns`,
	PanelPerformanceReviewGroupsUrl: (type: string) => `/panel/performance-reviews/${type}/groups`,
	PanelPerformanceReviewGroupsPageUrl: (type: string, page: any) =>
		`/panel/performance-reviews/${type}/groups/page/${page}`,
	// panel careers
	PanelCareersUrl: () => `/panel/careers`,
	PanelCareerCategoriesUrl: () => `/panel/careers/categories`,
	PanelCareerRequestsUrl: () => `/panel/careers/requests`,
	PanelCareerRequestsPageUrl: (page: any) => `/panel/careers/requests/page/${page}`,
	// panel onboarding
	PanelOnboardingUrl: () => `/panel/careers/onboarding`,
	PanelOnboardingPageUrl: (page: any) => `/panel/careers/onboarding/page/${page}`,
	// panel projects
	PanelProjectsUrl: () => `/panel/projects`,
	PanelTasksUrl: () => `/panel/tasks`,
	PanelProjectsPageUrl: (page: number) => `/panel/projects/page/${page}`,
	PanelProjectTasksUrl: (projectId: number) => `/panel/projects/${projectId}/tasks`,
	PanelPrivateProjectsUrl: () => `/panel/projects/private`,
	PanelPrivateProjectsPageUrl: (page: number) => `/panel/projects/private/page/${page}`,
	PanelProjectActivitiesUrl: () => `/panel/projects/activities`,
	PanelProjectInvitationsUrl: () => `/panel/projects/invitations`,
	PanelProjectInvitationsPageUrl: (page: number) => `/panel/projects/invitations/page/${page}`,
	// panel attendances
	PanelAttendancesUrl: () => `/panel/attendances`,
	PanelAttendancesPageUrl: (page: number) => `/panel/attendances/page/${page}`,
	PanelUserAttendancesUrl: (userId: number) => `/panel/attendances/${userId}`,
	// panel custom pages
	PanelCustomPagesUrl: () => `/panel/custom-pages`,
	PanelCustomPagesPageUrl: (page: number) => `/panel/custom-pages/page/${page}`,
	PanelCustomPageUrl: (id: number) => `/panel/custom-pages/${id}`,
	// panel disciplinary notes
	PanelDisciplinaryNotesUrl: () => `/panel/disciplinary-notes`,
	PanelDisciplinaryNotesPageUrl: (page: number) => `/panel/disciplinary-notes/page/${page}`,
	PanelUserDisciplinaryNotesUrl: (id: number) => `/panel/disciplinary-notes/${id}`,
	PanelReviewDisciplinaryNotesUrl: () => `/panel/disciplinary-notes/review`,
	PanelDisciplinaryNoteCategoriesUrl: () => `/panel/disciplinary-notes/categories`,
	// panel kitchens
	PanelKitchenUrl: () => `/panel/kitchen`,
	PanelKitchenReservationsUrl: (scheduleId: number) => `/panel/kitchen/reservations/${scheduleId}`,
	PanelKitchenFoodsUrl: () => `/panel/kitchen/foods`,
	// panel company settings
	PanelCompanySettingsUrl: () => `/panel/company-settings`,
	// panel settings
	PanelSettingsUrl: () => `/panel/settings`,
	// vira
	PanelViraUrl: () => `/panel/vira`,
	// panel announcements
	PanelAnnouncementsUrl: () => `/panel/announcements`,
	PanelAnnouncementsPageUrl: (page: number) => `/panel/announcements/page/${page}`,
	// panel mails
	PanelMailsUrl: () => `/panel/mails`,
	PanelMailsPageUrl: (page: number) => `/panel/mails/page/${page}`,
	PanelMailUrl: (noteId: number) => `/panel/mails/${noteId}`,
	// panel organization chart
	PanelOrganizationChartUrl: () => `/panel/organization-chart`,
	// panel users
	PanelUsersUrl: () => `/panel/users`,
	PanelUsersPageUrl: (page: number) => `/panel/users/page/${page}`,
	PanelUserUrl: (userId: number) => `/panel/users/${userId}`,
	PanelRolesUrl: () => `/panel/roles`,
	PanelOrganizationUnitsUrl: () => `/panel/organization-units`,
	// panel surveys
	PanelSurveysUrl: () => `/panel/surveys`,
	PanelSurveysPageUrl: (page: number) => `/panel/surveys/page/${page}`,
	PanelSurveyUrl: (surveyId: number) => `/panel/surveys/${surveyId}`,
	// panel categories
	PanelCategoriesUrl: () => `/panel/categories`,
	// panel dev tickets
	PanelDevTicketsUrl: () => `/panel/dev-tickets`,
	PanelDevTicketsPageUrl: (page: number) => `/panel/dev-tickets/page/${page}`,
	// panel contacts
	PanelContactsUrl: () => `/panel/contacts`,
	PanelContactsPageUrl: (page: number) => `/panel/contacts/page/${page}`,
	// panel chat
	PanelChatUrl: () => `/panel/chat`,
	// panel crm
	PanelCrmUrl: () => `/panel/crm`,
	// panel benefit funds
	PanelBenefitFundsUrl: () => `/panel/benefit-funds`,
	PanelBenefitFundsRequestsUrl: () => `/panel/benefit-funds/requests`,
	PanelBenefitFundsMembersUrl: () => `/panel/benefit-funds/members`,
	PanelBenefitFundsLoansUrl: () => `/panel/benefit-funds/loans`,
	PanelBenefitFundsLotteriesUrl: () => `/panel/benefit-funds/lotteries`,
	PanelBenefitFundsSettingsUrl: () => `/panel/benefit-funds/settings`,
	// panel cms
	PanelCmsUrl: () => `/panel/cms`,
	PanelCmsPostsUrl: (type: string) => `/panel/cms?type=${type}`,
	PanelCmsCreatePostUrl: (type: string) => `/panel/cms/posts/create?type=${type}`,
	PanelCmsEditPostUrl: (id: any) => `/panel/cms/posts/${id}`,
	// panel cms forms
	PanelCmsFormsUrl: () => `/panel/cms/forms`,
	PanelCmsFormUrl: (formId: number) => `/panel/cms/forms/${formId}`,
	// admin
	AdminLoginUrl: () => "/admin/login",
	AdminDashboardUrl: () => "/admin",
	// admin users
	ManageUsersUrl: () => `/admin/users`,
	ManageUsersPageUrl: (page: number) => `/admin/users/page/${page}`,
	// admin companies
	ManageCompaniesUrl: () => `/admin/companies`,
	ManageCompaniesPageUrl: (page: number) => `/admin/companies/page/${page}`,
	// admin logs
	ManageLogsUrl: () => `/admin/logs`,
	ManageLogsPageUrl: (page: number) => `/admin/logs/page/${page}`,
	// admin rules
	ManageRulesUrl: () => `/admin/rules`,
	// admin about us
	ManageAboutUsUrl: () => `/admin/about-us`,
	// admin contact us
	ManageContactUsUrl: () => `/admin/contact-us`,
	// admin metas
	ManageMetasUrl: () => `/admin/metas`,
	// admin slides
	ManageSlidesUrl: () => `/admin/slides`,
	// admin categories
	ManageCategoriesUrl: () => `/admin/categories`,
	// admin dev tickets
	ManageDevTicketsUrl: () => `/admin/dev-tickets`,
	ManageDevTicketsPageUrl: (page: number) => `/admin/dev-tickets/page/${page}`,
	// admin posts
	ManagePostsUrl: (type: CategoryTypes) => `/admin/posts?type=${type}`,
	ManagePostsPageUrl: (type: CategoryTypes, page: any) => `/admin/posts/page/${page}?type=${type}`,
	AdminCreatePostUrl: (type: CategoryTypes) => `/admin/posts/create?type=${type}`,
	AdminEditPostUrl: (id: any) => `/admin/posts/${id}`
}
